module.exports = "https://redage.akamaized.net/src/views/donate/main/assets/images/menu/shop.png";